import React from 'react'
import { StyledRadioForm } from './styled'

type Props = {
  name: string,
  defaultValue?: string,
  options: string[],
  required?: boolean,
  disabled?: boolean,
}

export const RadioForm: React.FC<Props> = ({ defaultValue, ...props }: Props) => {
  return <StyledRadioForm defaultValue={defaultValue || ''} {...props} />
}
